export default "__VITE_ASSET__CdEjJhLF__"